import React, { Component } from 'react';
import { Chart } from 'react-chartjs-2';
import { Container, Card, CardBody } from 'mdbreact';
import 'mdbreact/dist/css/mdb.css';
import axios from 'axios';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from "react-day-picker";
import 'react-day-picker/lib/style.css';
import ControlledExpansionPanels from '../log/CompanyList';
import BaseUrl from '../utils/api.js';
import {  Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import AuthService from '../Services/authService/authService';
import RealTimeService from '../Services/RealTimeService/realtimeService';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';


class Home extends Component {
    constructor(props) {
        super();
        this.state = {
            ChannelList: [{ pendding: true, value: [] }],
            Data: { DataPending: false, DataValue: null },
            startDateG: null,
            endDateG: null,
            CompanyList: [{ Companypendding: true, CompanyValue: [] }],
            HomeFilter: {
                HomeFilterStartDate: null,
                HomeFilterEndDate: null
            },
            isAutenticated: true,
            loading: false
        };
        this.setDates = this.setDates.bind(this);
    }
    startdate;
    enddate;
    channelChart1;
    webnodeChart2;
    componentDidMount() {

        let newstartDate = new Date();
        this.startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();    
       
        this.startdate =null;
        this.enddate = null;
        var that = this;
        that.setDates();      
     
    }
    setDates(){
        
        var StartDate = this.state.HomeFilter.HomeFilterStartDate;
        var EndDate = this.state.HomeFilter.HomeFilterEndDate;
        var startDateResult = "";
        var EndDateResult = "";   
        StartDate = this.OtherDate();
        startDateResult = new Date(StartDate);
        startDateResult = StartDate.getFullYear() + "-" + (StartDate.getMonth() + 1) + "-" + StartDate.getDate();

        EndDate = new Date();
        EndDateResult =  EndDate.getFullYear() + "-" + (EndDate.getMonth() + 1) + "-" + EndDate.getDate();
      
        this.setState({
            HomeFilter: {HomeFilterStartDate: startDateResult, HomeFilterEndDate: EndDateResult}
        },()=>{
                this.ChannelChart();
                this.WebNodeChart();
                this.getRealTimeData();
            }        
        );
    }
    getRealTimeData() {   
        this.setState({
            Data: { Datapendding: true, DataValue: [] }
        });
        let dataResult = RealTimeService.getRealTime();
        var that = this;    
        dataResult.then(function (data) {    
            that.setState({
                Data: { Datapending: false, DataValue: data.data }
            }, console.log());    
        }).catch((error) => {      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });     
    }
    getStartDateChart(day) {

        var  isDate = DateUtils.isDate(day);
        if(isDate && day)
        {
            if (day) {
                let newstartDate = new Date(day);
                this.startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
                
            } else{
                this.startdate = null;              
            }
            this.setState(state => {
                state.HomeFilter.HomeFilterStartDate = this.startdate;
                return state;
            }, () => {
                this.ChannelChart();
                this.WebNodeChart();
            }); 
        }
    }
    getEndDateChart(day) {
        var  isDate = DateUtils.isDate(day);
        if(isDate && day)
        {
            if (day) {
                let newendDate = new Date(day);
                this.enddate = newendDate.getFullYear() + "-" + (newendDate.getMonth() + 1) + "-" + newendDate.getDate();
            } else{
                this.enddate = null;    
            }            
            this.setState(state => {
                state.HomeFilter.HomeFilterEndDate = this.enddate;
                return state;
            }, ()=>{
                this.ChannelChart();
                this.WebNodeChart();
            });
        }
    }
    WebNodeChart() {
        this.setState({
            ChannelList: { pendding: true }
        });
        axios.get( BaseUrl + "WebNodeChart?startdate=" + this.state.HomeFilter.HomeFilterStartDate + "&enddate=" + this.state.HomeFilter.HomeFilterEndDate).then(response => {

            var WebNodeResult = [];
            WebNodeResult = response.data;

            let Channel = [];
            let Totals = [];
            let backColor = [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ];
            let borderColorA = [
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ];

            let ItemColor = [];
            let BorderItemColor = [];
            let i = 0;
            WebNodeResult.forEach((elem) => {
                Totals.push(elem.total);
                Channel.push(elem.WebNode);
                if (i <= 6) {
                    ItemColor.push(backColor[i]);
                    BorderItemColor.push(borderColorA[i]);
                } else if (i > 6) {
                    i = 0;
                    ItemColor.push(backColor[i]);
                    BorderItemColor.push(borderColorA[i]);
                }
                i++;
            });
            this.setState({
                ChannelList: { pendding: false, value: response.data }
            }, () => {
                var ctxB2 = document.getElementById("nodeChart").getContext('2d');
                if (this.webnodeChart2 != null) { this.webnodeChart2.destroy(); }
                this.webnodeChart2 = new Chart(ctxB2, {
                    type: 'bar',
                    data: {
                        labels: Channel,
                        datasets: [{
                            label: 'Total',
                            data: Totals,
                            backgroundColor: ItemColor,
                            borderColor: BorderItemColor,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        onClick: this.WebNodergoToLogList.bind(this),
                        legend:{
                            display: false,
                        }
                    }
                });
            });
        });
    }
    ChannelChart() {
        var email = sessionStorage.getItem('email');
        this.setState({
            ChannelList: { pendding: true },
        })
        axios.get( BaseUrl +"Grafic?startdate=" + this.state.HomeFilter.HomeFilterStartDate + "&enddate=" + this.state.HomeFilter.HomeFilterEndDate + "&email=" + email).then(response => {

            var dataResult = [];
            dataResult = response.data;      
            let Channel = [];
            let Totals = [];
            let backColor = [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ];
            let borderColorA = [
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ];
            let ItemColor = [];
            let BorderItemColor = [];
            let i = 0;
            dataResult.forEach((elem) => {
                Totals.push(elem.total);
                Channel.push(elem.Channel);
                if (i <= 6) {
                    ItemColor.push(backColor[i]);
                    BorderItemColor.push(borderColorA[i]);
                } else if (i > 6) {
                    i = 0;
                    ItemColor.push(backColor[i]);
                    BorderItemColor.push(borderColorA[i]);
                }
                i++;
            });
            this.setState({
                ChannelList: { pendding: false, value: response.data },
            }, () => {
                var ctxB = document.getElementById("barChart").getContext('2d');
                if (this.channelChart1 != null) { 
                    this.channelChart1.destroy(); 
                }
                this.channelChart1 = new Chart(ctxB, {
                    type: 'bar',
                    data: {
                        labels: Channel,
                        datasets: [{
                            label: 'Total',
                            data: Totals,
                            backgroundColor: ItemColor,
                            borderColor: BorderItemColor,
                            borderWidth: 1

                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }],
                        },
                        onClick: this.ChannelgoToLogList.bind(this),
                        
                        legend:{
                            display: false,
                        }
                    },
                });
            });
        }).catch((error) => {  
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    ChannelgoToLogList(event, array) {
       let activeElement = this.channelChart1.getElementAtEvent(event);
       if(activeElement !== "" && activeElement !== undefined && activeElement !== null && activeElement.length !== 0){
            this.props.history.push({
                pathname: '/log',
                state: {details:{ channel: activeElement[0]._model.label, startdate: this.startdate, enddate: this.enddate}}
            });
       }
    }
    WebNodergoToLogList(event, array) {
        let activeElement = this.webnodeChart2.getElementAtEvent(event);
       if(activeElement !== "" && activeElement !== undefined && activeElement !== null && activeElement.length !== 0) {
            this.props.history.push({
                pathname: '/log',
                state: {details:{ webnode: activeElement[0]._model.label, startdate: this.startdate, enddate: this.enddate}}
            });
       }
    }
    CleanDate(){
        this.setState(state => {
            state.HomeFilter.HomeFilterStartDate = null;
            state.HomeFilter.HomeFilterEndDate = null;
            return state;
        });  
        this.startdate = "";
        this.enddate = "";
        this.ChannelChart();
        this.WebNodeChart();
    }
    OtherDate(){
        var fecha = new Date();
        var otraFecha = fecha.setDate(fecha.getDate() - 7);        
        var date = new Date(otraFecha);
        var Result = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());        
        return Result;        
    }
    renderGrafic() {
        if (this.state.ChannelList.pending) {
            return <span className = "loader"> </span>;
        } else {
            return <div className = "card Logs">
                        <div className ="card-body">
                            <Container>
                                <canvas id ="barChart"> </canvas>
                            </Container >
                        </div>
                    </div>;    
        }
    }
    renderRT() {

        if (this.state.ChannelList.pending) {
            return <span className = "loader"> </span>;

        } else {
            return <div className = "card Logs">
                        <div className ="card-body" style={{'overflowX': 'scroll'}}>
                           <div className="row" style={{'paddingBottom': '1rem'}}>                            
                                <div className="col-6" >
                                     <span className="badge badge-pill badge-light">Broadcast Messages: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.BroadcastMessages : ""}</span>
                                </div>
                                <div className="col-6">
                                     <span className="badge badge-pill badge-light">Connected: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.ConnectedDevices : ""}</span>
                                </div>                               
                           </div>
                           <div className="row" style={{'paddingBottom': '1rem'}}>
                               <div className="col-6">
                                     <span className="badge badge-pill badge-light">Count Events: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.CountEvents : ""}</span>
                                </div>
                                <div className="col-6">
                                     <span className="badge badge-pill badge-light">Data Sources Errors: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.DataSourcesErrors : ""}</span>
                                </div>                               
                           </div>
                           <div className="row" style={{'paddingBottom': '1rem'}}>
                                <div className="col-6">
                                    <span className="badge badge-pill badge-light">Disconnected: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.DisconnectedDevices : ""}</span>
                                </div>
                                <div className="col-6">
                                    <span className="badge badge-pill badge-light">Drivers Errors: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.DriversErrors : ""}</span>
                                </div>                               
                           </div>
                           <div className="row" style={{'paddingBottom': '1rem'}}>
                                <div className="col-6">
                                     <span className="badge badge-pill badge-light">Pending Serial Requests: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.PendingSerialRequests : ""}</span>
                                </div>
                                <div className="col-6">
                                     <span className="badge badge-pill badge-light">Pending Status Requests: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.PendingStatusRequests : ""}</span>
                                </div>
                           </div>   
                           <div className="row" style={{'paddingBottom': '1rem'}}>                     
                                <div className="col-6">
                                      <span className="badge badge-pill badge-light">Count Commands: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.CountCommands : ""}</span>
                                </div>
                                <div className="col-6">
                                      <span className="badge badge-pill badge-light">Data Sources Operations: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.DataSourcesOperations : ""}</span>
                                </div>
                           </div>     
                           <div className="row" style={{'paddingBottom': '1rem'}}>  
                                <div className="col-6">
                                      <span className="badge badge-pill badge-light">Max Delivered Events: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.MaxDeliveredEvents : ""}</span>
                                </div>
                                <div className="col-6">
                                      <span className="badge badge-pill badge-light">Queues Errors: {(this.state.Data.DataValue != null) ? this.state.Data.DataValue.QueuesErrors : ""}</span>
                                </div>
                           </div>                          
                        </div>
                    </div>;    
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        return ( 
            <div id="divContainer">
                <BlockUi tag="div" blocking={this.state.ChannelList.pendding} loader={ <div className="loader"></div>} >
                <MainLayout/><ToastContainer hideProgressBar/>
                <div className = "container" >
                    <div className = "row" >
                        <div className = "col-12" >
                          <Card >
                            <CardBody  style={{'height': '70px'}}>
                                <div className = "row" style={{'marginTop': '-5px'}}>
                                    <div className = "col-2" style = {{ 'paddingTop': "10px" } } > <span style = {{ 'fontWeight': 'bold' } }> Start Date </span></div >
                                    <div className = "col-3" >
                                        <div className = "form-group" >
                                            <DayPickerInput onDayChange = { day => this.getStartDateChart(day)}
                                            format = { "YYYY" }
                                            value={this.state.HomeFilter.HomeFilterStartDate ? this.state.HomeFilter.HomeFilterStartDate : this.OtherDate()}
                                            /> 
                                        </div>
                                    </div>
                                    <div className = "col-2 control-label" style = {{ 'paddingTop': "10px" } } > <span style = {{ 'fontWeight': 'bold' } }> End Date </span></div >
                                    <div className = "col-3" >
                                        <div className = "form-group" >
                                            <DayPickerInput onDayChange = { day => this.getEndDateChart(day) }
                                            format = { "YYYY" }
                                            value={this.state.HomeFilter.HomeFilterEndDate ? this.state.HomeFilter.HomeFilterEndDate : new Date()}
                                            />
                                        </div>
                                     </div>   
                                     <div className = "col-2" style = {{ 'marginTop': "-6px" } }>
                                        <a className="btn btn-info" style={{ 'padding': '0.5rem 1.10rem' }} onClick={(e) => this.setDates(e)} >Clean Date</a>                                    
                                     </div>   
                                </div>
                            </CardBody>
                         </Card>
                        </div>
                    </div><br/ >
                </div>
                 <div className = "container-fluid" >
                    <div className = "row" >
                            <div className = "col-4" > {this.renderGrafic()}</div>
                            <div className = " col-4 " >
                              <div className = "card Logs" >
                                  <div className = "card-body" >
                                    <Container>
                                        <canvas id = "nodeChart" onClick = { this.handleClick } ref = {(ref) => this.nodeChart = ref } > </canvas>
                                    </Container>                                         
                                    </div> 
                               </div>         
                            </div>                                                       
                    </div><br/> 
                 </div>  
                 <div className = "container-fluid" >
                    <div className = "row" >
                        <div className = "col-lg-4 col-md-6 col-sm-6 " > 
                            <Card >
                                <CardBody style={{ 'padding': '10px', overflowY: 'scroll', height: '304px'}} >
                                    <ControlledExpansionPanels  StartDate={this.state.HomeFilter.HomeFilterStartDate} EndDate={this.state.HomeFilter.HomeFilterEndDate}/> 
                                </CardBody>
                            </Card>                         
                        </div>
                        <div className = "col-lg-4 col-md-6 col-sm-6 " > {this.renderRT()}</div>                            
                    </div> 
                 </div>   
                 </BlockUi>
         </div>
        );
    }
}
export default Home;


// WEBPACK FOOTER //
// ./src/home/home.jsx